module.exports = __webpack_public_path__ + "assets/img/11_847_big.b95c1758.jpg";